import { Form } from 'formsy-semantic-ui-react'
import React, { Component } from 'react'
import { Comment, Header, Button, GridColumn, Grid, Dimmer, Loader, Label, Icon, Image, Segment } from 'semantic-ui-react'
import { getRequestNotes, addRequestNotes } from '../../services/Manager';
import './ServiceRequestNotesNew.less'
import moment from 'moment';
import DGTextarea from 'components/FormControls/Textarea/DGTextarea';
import user_icon from '../../assets/images/newui/newrequestpage/user-icon.svg'
import {SocketContext} from '../../context/socket';
import { ON_NEW_SBR_NOTE_RECEIVED } from 'constants/socketIOListener';


const initialState = { notes: [], notesCharacterCount: 0, note: '', loading: false, showForm: false };

class ServiceRequestNotesNew extends Component {
    static contextType = SocketContext
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {
        const socket = this.context
        this.getNotes();
        this.implementWebSockets(socket);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.singleBuyerRequestID != this.props.singleBuyerRequestID) {
            const socket = this.context
            this.getNotes();
            this.implementWebSockets(socket);
        }
    }

    scrollToTop = () => { 
            var elements = document.getElementsByClassName("notes-list-item");
            if (elements.length) {
                let element = elements[0];
                element.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center'
                });
            }
    }

    implementWebSockets = (socket) => {
        let sbrID = this.props.singleBuyerRequestID;
        if (sbrID) {
            let key = ON_NEW_SBR_NOTE_RECEIVED.replace("<SBR_ID>", sbrID);
            socket.on(key, (data) => {
                let newNote = data.note;
                if (newNote.length > 0) {
                    let allNotesState = this.state.notes
                    let checkNote = allNotesState.filter((note) => { return note.sbrNoteID == newNote[0].sbrNoteID })
                    if (checkNote.length == 0) {
                        allNotesState = [newNote[0], ...allNotesState];
                        this.setState({ notes: allNotesState }, () => {
                            setTimeout(() => {
                                this.scrollToTop();
                            }, 10);
                        })
                    }
                }
            });
        }
    }


    getNotes = async () => {
        this.setState({ loading: true });
        const singleBuyerRequestID = this.props.singleBuyerRequestID;
        const notes = await getRequestNotes(singleBuyerRequestID);
        if (notes.resStatus === 200) {
            setTimeout(() => {
                this.setState({ notes: notes.data, notesCharacterCount: 0, note: '', loading: false, showForm: false }, () => {
                    /*var objDiv = document.getElementById("notes");
                    objDiv.scrollTop = objDiv.scrollHeight;*/
                });
            }, 500);
        }
    }

    onCancel = () => {
        this.props.onClose();
    }

    onNotesChange = (e, data) => {
        this.setState({ notesCharacterCount: data.value.length, note: data.value });
    }


    onNotesAddCancel = () => {
        this.setState({ notesCharacterCount: 0, note: '', showForm: false });
    }

    onShowForm = () => {
        this.setState({ showForm: true });
        setTimeout(() => {
            var element = document.getElementById("notes-text-area");
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: "nearest"
                });
            }
        }, 10);
    }

    resetState = () => {
        this.setState({ notesCharacterCount: 0, note: '' });
    }
    openNotesModal = () => {
        this.props.openModal();
    }

    expandRequestNotes = () => {
        this.props.expandComponent();
    }

    render() {
        const { notes } = this.state;

        return (
            <>
                <div className={`request-notes-new form-container ${this.props.isExpand ? "expand" : ""} ${this.state.loading ? "loading" : ""}`}>
                    {/* <Dimmer active={this.state.loading}>
                    <Loader active={this.state.loading} inverted />
                    </Dimmer> */}
                    {
                        this.state.loading ?
                            <Dimmer active={true}>
                                <Loader active={true} size='massive'  > </Loader>
                            </Dimmer>
                            :
                            <>
                                <div className={"header-container"}>
                                    <div className={"heading"}>
                                        {"Notes"}
                                    </div>
                                    <div className={"actions-container"}>

                                        {
                                        this.props.addRequestNotesEnabled ?     
                                        <button onClick={() => this.openNotesModal()} className={"add-button"}>
                                            <div className={"button-text"}>
                                                {"Add Notes"}
                                            </div>
                                            <svg className={"icon-img"} id="add-button" xmlns="http://www.w3.org/2000/svg" width="21.023" height="21.023" viewBox="0 0 21.023 21.023">
                                                <g id="Group_13301" data-name="Group 13301" transform="translate(0 0)">
                                                    <g id="Group_13300" data-name="Group 13300" transform="translate(0 0)">
                                                        <path id="Path_28971" data-name="Path 28971" d="M20.147,9.636a.876.876,0,0,0-.876.876A8.759,8.759,0,1,1,16.728,4.34a.876.876,0,0,0,1.243-1.234,10.512,10.512,0,1,0,3.052,7.406A.876.876,0,0,0,20.147,9.636Z" transform="translate(0 0)" />
                                                    </g>
                                                </g>
                                                <g id="Group_13303" data-name="Group 13303" transform="translate(6.132 6.132)">
                                                    <g id="Group_13302" data-name="Group 13302">
                                                        <path id="Path_28972" data-name="Path 28972" d="M119.884,115.5h-2.628v-2.628a.876.876,0,1,0-1.752,0V115.5h-2.628a.876.876,0,1,0,0,1.752H115.5v2.628a.876.876,0,1,0,1.752,0v-2.628h2.628a.876.876,0,1,0,0-1.752Z" transform="translate(-112 -112)" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </button> : ""
                                        }
                                        {
                                            window.innerWidth > 768 &&
                                            <div onClick={() => this.expandRequestNotes()} data-tooltip={`${this.props.isExpand ? 'Compress' : 'Expand'}`} data-position="left center" data-inverted="" className={"expend-icon-container"}>
                                                {
                                                    this.props.isExpand ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.036" height="18.953" viewBox="0 0 19.036 18.953">
                                                            <g id="Group_15460" data-name="Group 15460" transform="translate(0.527 0.501)">
                                                                <g id="Group_15457" data-name="Group 15457" transform="translate(0 0.001)">
                                                                    <path id="Path_29151" data-name="Path 29151" d="M5.791,5.038c0-.1,0-.151,0-.206q-.01-1.211-.019-2.423c0-.354.14-.483.495-.5.538-.024.64.125.637.622-.008,1.186.007,2.372.012,3.559,0,.155,0,.311,0,.466a.373.373,0,0,1-.384.4q-2.128.005-4.256,0a.419.419,0,0,1-.424-.406c0-.01,0-.02,0-.03-.048-.544.19-.7.658-.692.752.017,1.5,0,2.257,0h.209c-.08-.082-.132-.138-.187-.191Q2.509,3.371.225,1.1A.584.584,0,0,1,.037.45a.556.556,0,0,1,.917-.2L4.739,4l.914.907c.035.035.072.068.138.13" transform="translate(0 -0.081)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                    <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.474c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.787c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.454,0-.054,0-.108,0-.162l-.057-.038" transform="translate(-0.009 -353.826)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                    <path id="Path_29153" data-name="Path 29153" d="M366.754,4.946c.052-.06.1-.124.155-.18l4.554-4.53a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.616c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0A.457.457,0,0,1,370.6,6a.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.223a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-354.5 0)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                    <path id="Path_29154" data-name="Path 29154" d="M367.077,367.051c0,.085,0,.134,0,.183q0,1.235.007,2.469c0,.344-.132.473-.472.484-.464.016-.641-.049-.637-.624.01-1.207-.006-2.414-.012-3.62,0-.115.005-.231,0-.345a.385.385,0,0,1,.416-.455H369.1c.48,0,.96,0,1.439,0a.427.427,0,0,1,.471.453c0,.06,0,.121,0,.182a.46.46,0,0,1-.5.489q-1.212,0-2.424,0h-.2c.059.062.094.1.131.138q2.309,2.3,4.62,4.592a.575.575,0,0,1,.179.642.545.545,0,0,1-.869.235c-.189-.158-.359-.34-.534-.515l-4.211-4.188c-.032-.032-.066-.062-.128-.121" transform="translate(-354.853 -354.06)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.003" height="18.946" viewBox="0 0 19.003 18.946">
                                                            <g id="Group_15459" data-name="Group 15459" transform="translate(0.5 0.5)">
                                                                <g id="Group_15457" data-name="Group 15457" transform="translate(0 -0.001)">
                                                                    <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.473c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.786c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.453,0-.054,0-.108,0-.162l-.057-.038" transform="translate(11.071 -364.898)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                    <path id="Path_29153" data-name="Path 29153" d="M366.754,4.945c.052-.06.1-.124.155-.18L371.462.236a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.615c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0a.457.457,0,0,1,.484.264.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.222a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-365.594 11.078)" fill="#c0b8fd" stroke="#c0b8fd" stroke-width="1" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className={"notes-container"}>
                                    <div className={"notes-list"}>
                                        {
                                            notes.map((note, noteIndex) => {
                                                return (
                                                    <>
                                                        <div className={"notes-list-item"}>
                                                            <div className={"notes-date-container"}>
                                                                <div className={"month"}>
                                                                    {moment(note.createdAt).format('MMM')}
                                                                </div>
                                                                <div className={"date"}>
                                                                    {moment(note.createdAt).format('DD')}
                                                                </div>
                                                            </div>
                                                            <div className={"notes-content-container"}>
                                                                <div className={"note-message"}> {note.note}</div>
                                                                <div className={"note-author-date-container"}> 
                                                                    <img className={"user-icon"} src={user_icon}></img>  {note.firstName} 
                                                                    {/* <img className={"clock-icon"} src={user_icon}></img>   */}
                                                                    <span className={"clock-icon"}>{moment(note.createdAt).format('DD MMMM HH:mm')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={"seperator"}>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </>
        )
    }
}

export default ServiceRequestNotesNew
